import { render } from "./Modal.pug?vue&type=template&id=3b587a9f&lang=pug"
import script from "./Modal.js?vue&type=script&lang=js"
export * from "./Modal.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__